// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2tYu9","inputDescription":"styles_inputDescription__3AFRX"};